import { Button, Popconfirm, Table } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { AppImagePreview } from "components";
import { MedicineMaterial } from "./types";
import { isS3Image } from "./utils";

type MaterialImagesTableProps = {
  materials: MedicineMaterial[];
  removingIds: number[];
  hasDrafts: boolean;
  onRemove: (id: number) => void;
};

export const MaterialImagesTable = ({
  materials,
  removingIds,
  hasDrafts,
  onRemove,
}: MaterialImagesTableProps) => {
  if (!materials.length) {
    return null;
  }

  return (
    <Table<MedicineMaterial>
      dataSource={materials}
      rowKey="id"
      pagination={false}
      style={{ marginBottom: hasDrafts ? 24 : 0 }}
    >
      <Table.Column<MedicineMaterial>
        width={180}
        dataIndex="imageUrl"
        key="imageUrl"
        title="Превью"
        render={(value) => (
          <AppImagePreview imageURL={value} useS3={isS3Image(value)} />
        )}
      />
      <Table.Column<MedicineMaterial>
        width={180}
        dataIndex="detailImage"
        key="detailImage"
        title="Детальное"
        render={(value) => (
          <AppImagePreview imageURL={value || ""} useS3={isS3Image(value)} />
        )}
      />
      <Table.Column<MedicineMaterial>
        width={120}
        dataIndex="ord"
        key="ord"
        title="Порядок"
        render={(value) => value ?? "-"}
      />
      <Table.Column<MedicineMaterial>
        width={180}
        fixed="right"
        key="actions"
        title="Действия"
        render={(_, record) => (
          <Popconfirm
            title="Удалить картинку?"
            okText="Удалить"
            cancelText="Отмена"
            onConfirm={() => onRemove(record.id)}
          >
            <Button
              danger
              size="small"
              icon={<DeleteOutlined />}
              loading={removingIds.includes(record.id)}
            >
              Удалить
            </Button>
          </Popconfirm>
        )}
      />
    </Table>
  );
};
